import { Box, Checkbox, TextareaAutosize, Typography, useTheme } from "@mui/material";
import PageHeader from "../../../components/PageHeader/PageHeader";
import { useFormikContext } from "formik";
import { t } from "i18next";
import PropTypes from "prop-types";

const CancelledOrReturnedOrPendingAgreementInfo = ({ status }) => {
  const theme = useTheme();
  const isDisabled = status?.id !== 3 && status?.id !== 4;
  const formik = useFormikContext();

  return (
    <>
      <PageHeader title={t("CancellationInformation").toUpperCase()} />
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3, margin: { xs: '24px 0', md: '64px 49px' }, bgcolor: theme.palette.background.paper, borderRadius: 3, boxShadow: { xs: 'none', md: '0 2px 12px 0 rgba(11, 60, 93, 0.06)' }, p: { xs: 2, md: 3 } }}>
        <TextareaAutosize
          disabled={isDisabled}
          name="cancellationNote"
          style={{
            background: theme.palette.background.default,
            minHeight: "90px",
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: "8px",
            padding: "10px",
            resize: "none",
            fontFamily: "inherit",
            fontSize: 15,
            color: theme.palette.text.primary,
          }}
          placeholder={"Cancellation Note (optional)"}
          value={formik.values.cancellationNote || ""}
          onChange={formik.handleChange}
        />
      </Box>
    </>
  );
};

CancelledOrReturnedOrPendingAgreementInfo.propTypes = {
  status: PropTypes.object.isRequired,
};

export default CancelledOrReturnedOrPendingAgreementInfo;
